import { Injectable, EventEmitter } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { BehaviorSubject } from 'rxjs';
import { AngularFireDatabase } from '@angular/fire/database';
import { AngularFireAuth } from '@angular/fire/auth';
import { take } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { apiurl } from './../general/global';

@Injectable()
export class MessagingService {
  all_token = [];
  currentMessage = new BehaviorSubject(null);
  user_id_send = localStorage.getItem('customerId');
  notification_count: number;
  dash_notification_count: number;

  constructor(
    private angularFireMessaging: AngularFireMessaging,
    private angularFireDB: AngularFireDatabase,
    private angularFireAuth: AngularFireAuth,
    private http: HttpClient
  ) {
    this.angularFireMessaging.messages.subscribe(
      (_messaging: AngularFireMessaging) => {
        _messaging.onMessage = _messaging.onMessage.bind(_messaging);
        _messaging.onTokenRefresh = _messaging.onTokenRefresh.bind(_messaging);
      })
  }

  tokenSave(userId, token) {
    var body = JSON.stringify({ 'userId': userId, 'token': token });
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    return this.http.post(apiurl + 'usermanagement/firebase/', body, options)
  }

  tokenGet(userId) {
    var body = JSON.stringify({ 'userId': userId });
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    return this.http.post(apiurl + 'usermanagement/getfirebaseToken/', body, options)
  }

  updateToken(userId, token) {
    // we can change this function to request our backend service
    this.angularFireAuth.authState.pipe(take(1)).subscribe(
      () => {
        const data = {};
        data[userId] = token
        this.angularFireDB.object('fcmTokens/').update(data)
      })
  }


  requestPermission(userId) {
    this.angularFireMessaging.requestToken.subscribe(
      (token) => {
        console.log("newww")
        console.log(token);
        this.updateToken(userId, token);
        this.tokenSave(userId, token).subscribe(data => {

        });
      },
      (err) => {
        console.error('Unable to get permission to notify.', err);
      }
    );
  }

  //requestPermission() {
  //  this.angularFireMessaging.requestToken.subscribe(
  //    (token) => {
  //      console.log(token);
  //    },
  //    (err) => {
  //      console.error('Unable to get permission to notify.', err);
  //    }
  //  );
  //}
  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (payload) => {
        console.log("new message received. ", payload);
        this.currentMessage.next(payload);
        this.showCustomNotification(payload);
      })
  }

  showCustomNotification(payload: any) {
    let notify_data = payload['notification'];
    let title = notify_data['title'];
    let options = {
      body: notify_data['body'],
      icon: "https://homepages.cae.wisc.edu/~ece533/images/airplane.png",
    };
    console.log("new message received", notify_data);
    let notify: Notification = new Notification(title, options)

    notify.onclick = event => {
      event.preventDefault();
      window.location.href = "http://localhost:4200/";
    }
  }


  sendPushMessage(userId, title, message) {
    console.log('kkkkkk', userId, title, message)
    this.tokenGet(userId).subscribe(res => {
      this.all_token = res['data'];

      let data = {
        "notification": {
          "title": title,
          "body": message,
          "click_action": "http://localhost:4200/",
          "icon": "https://homepages.cae.wisc.edu/~ece533/images/airplane.png",
          "sound": "default"
        },
        "registration_ids": this.all_token,
        //"to": "cZPv0CopjNwnfDPIf7mP3a:APA91bFsJlpn7eBmtcVeX3nKmQ9Ua120er8a2FSk4QEtKJ5xBtwzu0R2GJ_7OjgEh-noGpdU00wkrolThL3O9emea_-pKz6MLq3cdrfN1kTBU1eunY22KHtm9q5X2zZL_1sMvOYFg46q"
      }

      let postData = JSON.stringify(data);
      let url = "https://fcm.googleapis.com/fcm/send";
      this.http.post(url, postData, {
        headers: new HttpHeaders()
          // put the server key here
          .set('Authorization', 'key=AAAASssetnI:APA91bH8yWWQtEsuzoolawTiY8_bEEiXEwGn8DVw_0yYfYDrPmpqkc1M3cCXg1z-gaLIGODVidMY7aRXsQnkI3O4e9q0KzoieThuoh5HwgSfYUpHDte15i5EenZMeL7EGKsJNJdOIcq9')
          .set('Content-Type', 'application/json'),
      })
        .subscribe((response: Response) => {
          console.log(response)
        },
          (error: Response) => {
            console.log(error);
            console.log("error" + error);
          });

    });


  }



  //notification

  totoal_count_notification() {
    var body = JSON.stringify({ 'userId': this.user_id_send });
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    this.http.post(apiurl + 'usermanagement/unread_notifcation_count/', body, options).subscribe(res => {
      this.notification_count = res['data'];
      console.log("startred...........", this.notification_count)
    });
  }

  totoal_count_notification_superadmin() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    this.http.post(apiurl + 'usermanagement/unread_notifcation_count_superadmin/', options).subscribe(res => {
      this.dash_notification_count = res['data'];
      console.log("startred...........", this.notification_count)
    });
  }

  total_message() {
    var body = JSON.stringify({ 'userId': this.user_id_send });
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    return this.http.post(apiurl + 'usermanagement/show_notification/', body, options)
  }

  total_message_superadmin() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    return this.http.post(apiurl + 'usermanagement/renewal_notifications/', options)
  }

  message_delete(delete_id) {
    var body = JSON.stringify({ 'id': delete_id });
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    return this.http.post(apiurl + 'usermanagement/delete_notification/', body, options)
  }
  read_message() {
    var body = JSON.stringify({ 'userId': this.user_id_send });
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    return this.http.post(apiurl + 'usermanagement/read_all_notification/', body, options)
  }
  read_message_superadmin() {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    return this.http.post(apiurl + 'usermanagement/read_all_notification_superadmin/', options)
  }

  create_notification(userId, title, message, mode) {
    var body = JSON.stringify({ 'userId': userId, 'title': title, 'message': message, 'mode': mode });
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' })
    let options = { headers: headers }
    this.http.post(apiurl + 'usermanagement/user_notification/', body, options).subscribe();
  }




  //one signal push notification //
  sendPushMessageOnesignal(userId, title, message) {
    console.log('kkkkkk', userId, title, message)

    let data =
    {
      "app_id": "4656653f-8105-412a-8df1-ab89c3d62d57",
      "include_external_user_ids": [userId],
      "headings": { "en": title },
      "contents": { "en": message }
    }

    let postData = JSON.stringify(data);
    let url = "https://onesignal.com/api/v1/notifications";
    this.http.post(url, postData, {
      headers: new HttpHeaders()
        .set('Authorization', 'Basic ZmZjODE0N2EtMTNkMS00ZWJlLWExMWQtYzA5NWE0NGQwNjE3')
        .set('Content-Type', 'application/json'),
    })
      .subscribe((response: Response) => {
        console.log(response)
      },
        (error: Response) => {
          console.log(error);
          console.log("error" + error);
        });

  }
}
